export default "__VITE_ASSET__B630CzNs__"